import { render, staticRenderFns } from "./TeacherRegister.vue?vue&type=template&id=a31fee20&scoped=true"
import script from "./TeacherRegister.vue?vue&type=script&lang=js"
export * from "./TeacherRegister.vue?vue&type=script&lang=js"
import style0 from "./TeacherRegister.vue?vue&type=style&index=0&id=a31fee20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31fee20",
  null
  
)

export default component.exports